<template>
  <div>
    <el-row style="margin-bottom:10px;" v-if="!IsDetail">
      <el-col :span="$store.state.isMB?8:4">
        <el-upload
          :headers="header"
          :action="uploadUrl"
          :data="{recordId:KeyId}"
          :on-progress="uploadProcess"
          :on-success="handleSuccess"
          :before-upload="beforeUpload"
          :show-file-list="false"
        >
          <el-button type="primary" size="mini" style="vertical-align:10px;">添加附件</el-button>
        </el-upload>
      </el-col>
      <el-col :span="$store.state.isMB?16:20">
        <el-progress v-show="showProgress" style="margin-top:6px;" :percentage="uploadPercent"></el-progress>
      </el-col>
    </el-row>
    <el-row
      v-loading="isLoading"
      v-for="(item, $index) in fileList"
      :key="item.AttachmentId"
      class="upload-item"
    >
      <el-col :span="2">
        <i class="el-icon-document" style="margin-left:10px;"></i>
      </el-col>
      <el-col :span="18">
        <span>{{item.FileName}}.{{item.Extension}}</span>
      </el-col>
      <el-col :span="4" style="color:#409EFF">
        <i class="el-icon-download" style="cursor: pointer" @click="download(item)"></i>
        <el-popconfirm
          title="确定删除吗？"
          confirmButtonType="text"
          @onConfirm="onDelete(item.AttachmentId,$index)"
          style="margin-left:15px"
        >
          <i slot="reference" v-if="!IsDetail" class="el-icon-delete" style="cursor: pointer"></i>
        </el-popconfirm>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from "@/api/web/attachment";
export default {
  props: {
    IsDetail: {
      type: Boolean,
      default: false,
    },
    uploadUrl: {
      type: String,
      default: "/api" + api.upload,
    },
    getDataFunc: {
      type: Function,
      default: api.list,
    },
    deleteFunc: {
      type: Function,
      default: api.delete,
    },
    KeyId: {
      type: Number,
      default: 0,
    },
    fileList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      isLoading: false,
      // fileList: [],
      fileDel: [],
      showProgress: false, //显示进度条
      uploadPercent: 0, //进度条的进度
    };
  },
  computed: {
    header() {
      let token = localStorage.getItem("token");
      if (token) {
        return { Authorization: "Bearer " + token };
      }
      return {};
    },
  },
  methods: {
    getData(initParams = null) {
      // if (!this.getDataFunc) {
      //   alert("请指定 attachUpload 公共组件上 get-data-func 属性对应的函数！");
      //   return false;
      // }
      // let params = {};
      // if (initParams != null) {
      //   params = { ...initParams };
      // }
      // this.getDataFunc(params).then((res) => {
      //   // console.log("getData", res);
      //   res.Data.forEach((item) => {
      //     let file = {
      //       AttachmentId: item.AttachmentId,
      //       RecordId: item.RecordId,
      //       TableName: item.TableName,
      //       FileUrl: item.FileUrl,
      //       FileName: item.FileName,
      //       Extension: item.Extension,
      //     };
      //     this.fileList.push(file);
      //   });
      // });
    },
    getFiles() {
      return this.fileList;
    },
    download(item) {
      let fileUrl = location.origin + "/api" + item.FileUrl;
      const elink = document.createElement("a");
      elink.download = item.FileName;
      elink.style.display = "none";
      elink.target = "_blank";
      elink.href = fileUrl;
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    },
    //上传前回调
    beforeUpload(file) {
      this.showProgress = true;
    },
    //进度条
    uploadProcess(event, file, fileList) {
      this.uploadPercent = file.percentage.toFixed(0) * 1;
    },
    //上传成功回调
    handleSuccess(res, file) {
      console.log("res.Data", res);
      if (res.Code == 1) {
        this.$message.error(res.Msg);
      } else {
        // console.log(res);
        let item = res.Data;
        this.fileList.push({
          AttachmentId: item.AttachmentId,
          RecordId: item.RecordId,
          TableName: item.TableName,
          FileUrl: item.FileUrl,
          FileName: item.FileName,
          Extension: item.Extension,
        });
        // this.$emit("input", this.fileList);
      }

      this.showProgress = false;
      this.uploadPercent = 0;
    },
    onDelete(id, index) {
      // this.isLoading = true;
      // this.deleteFunc({ id }).then((res) => {
      //   console.log("delete");
      //   this.isLoading = false;
      //   if (res.Code == 0) {
      //     this.fileList.splice(index, 1);
      //     // this.$emit("input", this.fileList);
      //   } else {
      //     this.$message.error(res.Msg);
      //   }
      // });
      if(this.fileList[index].T === 0) {
        this.fileList[index].T = 2;
        this.fileDel.push(this.fileList[index]);
      }
      this.fileList.splice(index, 1);
      // this.$emit("input", id);
    },
    clear() {
      this.fileDel = [];
      // this.fileList = [];
    },
  },
};
</script>

<style lang="scss">
.upload-item {
  height: 30px;
  line-height: 30px;
}
</style>